import { ConfirmOrderComponent } from './confirm-order/confirm-order.component';
import { SearchOrderReceivedComponent } from './search-order-received/search-order-received.component';
import { OrderNowComponent } from './order-now/order-now.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfirmOtpComponent } from './confirm-otp/confirm-otp.component';
import { DetailOrderComponent } from './detail-order/detail-order.component';

const routes: Routes = [
    { path: '', component: OrderNowComponent },
    { path: 'confirm-order', component: ConfirmOrderComponent },
    { path: 'confirm-otp', component: ConfirmOtpComponent },
    { path: 'detail-order', component: DetailOrderComponent },
    { path: 'detail-order/:phone/:orderCode', component: DetailOrderComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DigitalRoutingModule {
}
